<template>
  <div class="card-footer text-end mb-2" v-if="workflowData">
    <button class="btn btn-danger text-xs rounded-small" v-if="workflowData.workflow_status == 'pending' || workflowData.workflow_status == 'approved'" @click="declineWorkflow">
      Decline
    </button>
    <button class="btn btn-primary-color text-xs rounded-small mx-1" v-if="workflowData.workflow_status == 'pending' || workflowData.workflow_status == 'declined'" @click="approveWorkflow">
      Approve
    </button>
  </div>
</template>

<script>
export default {
  name: 'FooterActions',
  props: {
    workflowData: {
      type: Object,
      default: null
    }
  },
  methods: {
    declineWorkflow() {
      this.$emit('decline-workflow');
    },
    approveWorkflow() {
      this.$emit('approve-workflow');
    }
  }
}
</script>

<style scoped></style>
